

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import ajax from "../../lib/ajax";
@Component
export default class Notice extends AbpBase {
  noticeSpinShow: boolean = true;
  eachStatusOrderCount: any = {};
  get noticeList(): Array<any> {
    return this.$store.state.app.noticeList;
  }
  get unReadCount() {
    // return this.noticeList.filter(n => n.read == false).length;
    return 0;
  }
  get noticeArray() {
    return this.noticeList.filter(n => n.read == false && n.type === 0);
  }
  get noticeCount() {
    return this.noticeList.filter(n => n.read == false && n.type === 0).length;
  }
  get noticeLabel() {
    let name = this.L("Notice");
    if (this.noticeCount > 0) {
      return `${name}(${this.noticeCount})`;
    } else {
      return name;
    }
  }
  created() {
    // this.GetPcEachStatusOrderCount();
  }
  // GetPcEachStatusOrderCount() {
  //   ajax.get(`/api/services/app/Order/GetPcEachStatusOrderCount`).then(res => {
  //     this.eachStatusOrderCount = res.data.result;
  //   });
  // }
  getNotices() {
    setTimeout(() => {
      this.noticeSpinShow = false;
    }, 2000);
  }
}
